import { render, staticRenderFns } from "./ConfiguracaoCaixaPostal.vue?vue&type=template&id=76c1b852&"
import script from "./ConfiguracaoCaixaPostal.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoCaixaPostal.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracaoCaixaPostal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports